module.exports = kolibriGlobal;